import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import firebase from 'firebase'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const SocialSharing = require('vue-social-sharing')
Vue.use(SocialSharing)

const VueLuxon = require('vue-luxon')
Vue.use(VueLuxon)

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas, far, fab) // TODO: how to import only the icons i need instead of both sets?
dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver

Vue.use(VueClipboard)

const firebaseConfig = {
  apiKey: 'AIzaSyB426_mLbhc33T65QChJ4gfGRxnmb-lC00',
  authDomain: 'wannagrowmeapi.firebaseapp.com',
  databaseURL: 'https://wannagrowmeapi.firebaseio.com',
  projectId: 'wannagrowmeapi',
  storageBucket: 'wannagrowmeapi.appspot.com',
  messagingSenderId: '568492697853',
  appId: '1:568492697853:web:a4cedc046f30b2028ab694'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
(firebase as any).getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h: any) => h(App)
}).$mount('#app')
